const blogs = [
  {
    slug: "construction-company-in-india",
    title: "Construction Company in India – Complete Guide 2025",
    description: "Explore top construction companies in India, their projects, and future trends.",
    content: `
      <h2>Introduction</h2>
      <p>India is home to many leading construction companies...</p>

      <h2>Top Construction Projects</h2>
      <p>Infrastructure, road construction, tunnels, water supply, LCEPL, irrigation, wastewater, India, Infrastructure, Building, sewerage, building construction, road construction, water supply, water treatment plant, commercial construction...</p>

      <h2>Conclusion</h2>
      <p>Choosing the right construction company ensures quality and trust...</p>
    `
  },
  {
    slug: "water-treatment-plant",
    title: "Importance of Water Treatment Plants",
    description: "Understand the role of water treatment plants in urban development.",
    content: `
      <h2>Why Water Treatment is Important</h2>
      <p>Clean water is essential for sustainable cities...</p>
    `
  }
];

export default blogs;
